(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ampema-campaign-timer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ampema-campaign')) {
    customElements.define('ampema-campaign', class extends HTMLElement {
      connectedCallback() {
        const deadline = Date.parse(this.dataset.deadline);
        const preview = this.dataset.preview === 'true';
        const dialog = this.querySelector('dialog');
        this.querySelector('[data-open-terms]')?.addEventListener('click', event => {
          if (dialog && typeof dialog.showModal === 'function') {
            event.preventDefault();
            dialog.showModal();
          }
        });
        this.querySelector('[data-close-terms]')?.addEventListener('click', () => dialog.close());
        dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
        if (!Number.isFinite(deadline)) {
          this.hidden = true;
          return;
        }
        const label = this.querySelector('[data-deadline-label]');
        if (label) label.textContent = new Intl.DateTimeFormat('nb-NO', { dateStyle: 'short', timeStyle: 'short', timeZone: 'Europe/Oslo' }).format(deadline);
        const update = () => {
          const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
          if (remaining === 0 && !preview) this.hidden = true;
          const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
          for (const [unit, value] of Object.entries(values)) {
            const target = this.querySelector('[data-unit="' + unit + '"]');
            if (target) target.textContent = String(value).padStart(2, '0');
          }
          if (remaining === 0 && this.interval) clearInterval(this.interval);
        };
        update();
        if (deadline > Date.now()) this.interval = setInterval(update, 1000);
      }
      disconnectedCallback() { clearInterval(this.interval); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ampema-guide-form"] && !Shopify.designMode) return;
  try {
    
const guideProduct = new URLSearchParams(window.location.search).get('produkt');
if(guideProduct && document.getElementById('guide-source')){document.getElementById('guide-source').value=guideProduct;document.getElementById('guide-source-wrap').hidden=false;}
const guideForm = document.getElementById('AmpemaGuide');
if (guideForm) {
  const callback = guideForm.querySelector('#guide-callback');
  const phone = guideForm.querySelector('#guide-phone');
  const phoneLabel = guideForm.querySelector('label[for="guide-phone"]');
  const sendButton = guideForm.querySelector('button[type="submit"]');
  if (callback && phone && phoneLabel && sendButton) {
    const optionalPhoneLabel = phoneLabel.textContent;
    const defaultSendLabel = sendButton.textContent;
    const updateCallback = () => {
      phone.required = callback.checked;
      phoneLabel.textContent = callback.checked ? phoneLabel.dataset.requiredLabel : optionalPhoneLabel;
      sendButton.textContent = callback.checked ? sendButton.dataset.callbackLabel : defaultSendLabel;
    };
    callback.addEventListener('change', updateCallback);
    window.addEventListener('pageshow', updateCallback);
    updateCallback();
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsgn-hero"] && !Shopify.designMode) return;
  try {
    
  const setupDsgnHero = (hero) => {
    if (hero.dataset.initialized === 'true') return;
    hero.dataset.initialized = 'true';

    const slides = [...hero.querySelectorAll('[data-hero-slide]')];
    const dots = [...hero.querySelectorAll('[data-hero-dot]')];
    const toggle = hero.querySelector('[data-hero-toggle]');
    const pauseIcon = hero.querySelector('[data-pause-icon]');
    const playIcon = hero.querySelector('[data-play-icon]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const delay = Number(hero.dataset.delay) || 6000;
    let current = 0;
    let requestedSlide = 0;
    let timer;
    let paused = hero.dataset.autoplay !== 'true' || reduceMotion;

    const showSlide = async (index) => {
      const requestId = ++requestedSlide;
      const nextImage = slides[index]?.querySelector('img');
      if (nextImage) {
        nextImage.loading = 'eager';
        try { await nextImage.decode(); } catch {}
      }
      if (requestId !== requestedSlide) return;
      current = index;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === current));
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = undefined;
    };

    const start = () => {
      stop();
      if (!paused && slides.length > 1) {
        timer = window.setInterval(() => showSlide((current + 1) % slides.length), delay);
      }
    };

    const syncToggle = () => {
      if (!toggle) return;
      toggle.setAttribute('aria-label', paused ? 'Start bildevisningen' : 'Sett bildevisningen på pause');
      pauseIcon.hidden = paused;
      playIcon.hidden = !paused;
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        showSlide(index);
        start();
      });
    });

    toggle?.addEventListener('click', () => {
      paused = !paused;
      syncToggle();
      start();
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);

    syncToggle();
    start();
  };

  document.querySelectorAll('[data-dsgn-hero]').forEach(setupDsgnHero);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-dsgn-hero]').forEach(setupDsgnHero);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) { this.header.classList.add('shopify-section-header-sticky'); }
      this.currentScrollTop = 0; this.preventReveal = false; this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this); this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight(){ document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback(){ this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); window.removeEventListener('scroll', this.onScrollHandler); }
    createObserver(){ let observer = new IntersectionObserver((entries, ob)=>{ this.headerBounds = entries[0].intersectionRect; ob.disconnect(); }); observer.observe(this.header); }
    onScroll(){
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header'); if (this.preventHide) return; requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) { requestAnimationFrame(this.reveal.bind(this)); }
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(()=>{ this.preventReveal=false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header'); requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
    reveal(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky','animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset(){ if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate'); }
    closeMenuDisclosure(){ this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach((d)=>d.close()); }
    closeSearchModal(){ this.searchModal = this.searchModal || this.header.querySelector('details-modal'); this.searchModal.close(false); }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
